import './index.scss'
import _ from 'lodash'
import { useEffectOnce } from 'react-use'
import { PromoTable } from './components'
import { promoListPromise } from 'api/Promo'
import { useLocation } from 'react-router-dom'
import PromoToolbar from './components/PromoToolbar'
import React, { useState, useEffect, useCallback, useRef } from 'react'

const PromoList = props => {
  const ref = useRef()
  const location = useLocation()
  const [promos, setPromos] = useState([])
  const [params, setParams] = useState({ page: 1 })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    promoListPromise(too).then(resp => setPromos(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  function handleSearchChange (code) {
    handleParamsChange({ code }, 500)
  }
  // end

  return (
    <div className={'root'}>
      <div className={'content'}>
        <PromoToolbar handleSearchChange={handleSearchChange} params={params} {...props} />
        <br />
        <PromoTable data={promos} page={params.page} onPageChange={handlePageChange} {...props} />
      </div>
    </div>
  )
}

export default PromoList